const map = {
	"./images/aiDevelopment/ai-fields/ai2_pc@2x.png": 91840,
	"./images/aiDevelopment/ai-fields/ai2_sp@2x.png": 98,
	"./images/aiDevelopment/ai/ai1@2x.png": 92953,
	"./images/aiDevelopment/audio/ai_icon2@2x.png": 91174,
	"./images/aiDevelopment/image-videos/ai_icon3@2x.png": 32475,
	"./images/aiDevelopment/natural-language/ai_icon1@2x.png": 9075,
	"./images/aiDevelopment/sample-flow/ai3_pc@2x.png": 34426,
	"./images/aiDevelopment/sample-flow/ai3_sp@2x.png": 17964,
	"./images/aiDevelopment/time/ai_icon4@2x.png": 97865,
	"./images/branding/brand-building/branding1@2x.png": 24140,
	"./images/branding/logo-design/branding3@2x.png": 95662,
	"./images/branding/sample-flow/branding5@2x.png": 7961,
	"./images/branding/sample-flow/branding5_sp@2x.png": 80903,
	"./images/branding/ui-ux-design/branding4@2x.png": 58190,
	"./images/branding/visual-design/branding2@2x.png": 83492,
	"./images/ecommerce/consulting-01/ec_marketing1@2x.png": 42839,
	"./images/ecommerce/consulting-01/ec_marketing1_sp@2x.png": 29785,
	"./images/ecommerce/consulting-02/ec_marketing2@2x.png": 89455,
	"./images/ecommerce/consulting-02/ec_marketing2_sp@2x.png": 83473,
	"./images/ecommerce/consulting-03/ec_marketing3@2x.png": 871,
	"./images/ecommerce/consulting-03/ec_marketing3_sp@2x.png": 8329,
	"./images/ecommerce/development-01/ec_dev1@2x.png": 70443,
	"./images/ecommerce/development-01/ec_dev1_sp@2x.png": 87965,
	"./images/ecommerce/development-02/ec_dev2@2x.png": 74719,
	"./images/ecommerce/development-02/ec_dev2_sp@2x.png": 68481,
	"./images/ecommerce/development-03/ec_dev3@2x.png": 53547,
	"./images/ecommerce/development-03/ec_dev3_sp@2x.png": 37405,
	"./images/ecommerce/opengate-logo/logo_open@2x.png": 11400,
	"./images/rpaConsulting/rpa/rpa1_pc@2x.png": 27329,
	"./images/rpaConsulting/rpa/rpa1_sp1@2x.png": 54244,
	"./images/rpaConsulting/rpa/rpa1_sp2@2x.png": 42369,
	"./images/rpaConsulting/sample-flow/rpa2_pc@2x.png": 82454,
	"./images/rpaConsulting/sample-flow/rpa2_sp@2x.png": 9480,
	"./images/service/ai-development/service_icon2@2x.png": 44177,
	"./images/service/branding/service_icon4@2x.png": 93210,
	"./images/service/e-commerce/service_icon5@2x.png": 13335,
	"./images/service/rpa-consulting/service_icon3@2x.png": 28196,
	"./images/service/service-development/service_icon1@2x.png": 55697,
	"./images/serviceDevelopment/sample-flows/devlopment5_pc@2x.png": 71354,
	"./images/serviceDevelopment/sample-flows/devlopment5_sp@2x.png": 54892
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20659;